<template>
  <form
    v-loading="loading"
    @submit.prevent="save"
  >
    <b-modal
      ref="modal"
      :visible="true"
      :title="title"
      @hide="close"
    >
      <div class="form-group">
        <label>{{ $t('Name') }}</label>
        <input
          v-model="model.name"
          :minlength="3"
          type="text"
          class="form-control"
          required
        >
      </div>
      <div class="form-group">
        <input
          id="account-create-form-enabled"
          v-model="model.enabled"
          type="checkbox"
        >
        <label for="account-create-form-enabled">{{ $t('Active') }}?</label>
      </div>
      <template slot="modal-footer">
        <button
          type="submit"
          class="btn btn-primary"
        >
          {{ $t('Save') }}
        </button>
        <button
          type="button"
          class="btn btn-secondary"
          @click.prevent="close"
        >
          {{ $t('Close') }}
        </button>
      </template>
    </b-modal>
  </form>
</template>

<script>
import AccountModel from '../models/AccountModel';
import AccountService from '../services/AccountsService';
import ErrorsMixins from '../mixins/ErrorsMixins';

export default {
  name: 'AppPageAccountsCreate',
  mixins: [
    ErrorsMixins,
  ],
  data() {
    return {
      model: AccountModel.getDefaults(),
      loading: true,
    };
  },
  computed: {
    title() {
      if (this.model.id === 0) {
        return this.$t('Loading');
      }
      return `${this.$tc('Accounts', 1)} ID: ${this.model.id}`;
    },
    accountId() {
      return parseInt(this.$route.params.id, 10);
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      AccountService.findById(this.accountId).then(data => {
        this.model = AccountModel.fromApiResponse(data);
        this.loading = false;
      }).catch(() => {
        this.$errors_showNetworkErrorMessage();
        this.close();
      });
    },
    save() {
      this.loading = true;
      const data = AccountModel.toApiRequest(this.model);
      AccountService.update(this.accountId, data).then(() => {
        this.$toastr.success(this.$t('Action', { object: this.$tc('Accounts', 1), action: this.$t('updated') }), this.$t('Success'));
        this.loading = false;
      }).catch(error => {
        this.$toastr.error(error.message, this.$t('Error'));
        this.loading = false;
      });
    },
    close() {
      this.$router.back();
    },
  },
};
</script>
